import rawData from './cablefishChecklist.json';
import { ChecklistItemDefinition } from '../types';

export const CHECKLIST_ID = 'cablefish-function-tests';
export const CHECKLIST_VERSION = '2024-05-16';

export const checklistItems = rawData as ChecklistItemDefinition[];
